import { normalizeEmail } from '@/shared/lib';

import { OrganizationListFilter } from '@/entities/organizations';

import { OrganizationClientsKind } from '../config';

/**
 * Both hierarchies are queried through the same stream, but each one carries the
 * owner email in its own filter case.
 */
export const buildOrganizationClientsFilter = (params: {
  kind: OrganizationClientsKind;
  ownerEmail: string;
}): OrganizationListFilter => {
  const { kind, ownerEmail } = params;
  const email = normalizeEmail(ownerEmail);

  if (kind === 'dso') {
    return { case: 'ShowDSOClients', value: { DSOOwnerEmail: email } };
  }

  return {
    case: 'ShowDistributorClients',
    value: { DistributorOwnerEmail: email },
  };
};
